export type ExpenseReceiptSource = {
  receipt_image_url?: string | null;
  receipts?: Array<{ mime_type?: string | null; file_name?: string | null }> | null;
};

export function isPdfReceipt(options: {
  url?: string | null;
  mimeType?: string | null;
  fileName?: string | null;
}): boolean {
  const { url, mimeType, fileName } = options;
  if (mimeType?.toLowerCase().includes('pdf')) return true;
  if (fileName && /\.pdf$/i.test(fileName)) return true;
  if (url && /\.pdf(\?|#|$)/i.test(url.split('?')[0] ?? url)) return true;
  return false;
}

export function getExpenseReceiptInfo(expense: ExpenseReceiptSource) {
  const receipt = expense.receipts?.[0];
  const url = expense.receipt_image_url ?? null;
  const mimeType = receipt?.mime_type ?? null;
  const fileName = receipt?.file_name ?? null;
  return {
    url,
    mimeType,
    fileName,
    isPdf: isPdfReceipt({ url, mimeType, fileName }),
  };
}
